module.exports = __webpack_public_path__ + "img/member-icon2-04.2fd05342.png";